/** GitHub release URLs — keep in sync with worker/downloads.js */
export const DOWNLOAD_URLS = {
  windows:
    "https://github.com/dustinwelch-alt/StrataViz-Releases/releases/latest/download/StrataViz-Setup.exe",
  mac_apple_silicon:
    "https://github.com/dustinwelch-alt/StrataViz-Downloads/releases/latest/download/StrataViz-AppleSilicon.dmg",
  mac_intel:
    "https://github.com/dustinwelch-alt/StrataViz-Downloads/releases/latest/download/StrataViz-Intel.dmg",
};

export const TRACKER_FALLBACK = "https://website.dustin-welch.workers.dev";
